// extracted by css-extract-rspack-plugin
export default {"workers__grid":"workers__grid-xLeigV","workersGrid":"workers__grid-xLeigV"};